import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import * as ReportApi from "../../services/report.service";
import { Placeholder } from "rsuite";
import Breadcrums from "../../common/breadcrumbs";
import RawDataEventsTab from "./RawDataEventsTab";

const RawDataPage = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Raw Data Events"), url: "" },
  ];

  const { data, isLoading } = useQuery({
    queryKey: ["report-list"],
    queryFn: () =>
      ReportApi.List({
        limit: 1000,
        lastKey: null,
        filters: {},
        sorting: {},
      }),
    refetchOnWindowFocus: false,
    retry: false,
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            {isLoading ? (
               <Placeholder.Paragraph
               className="w-100 admin-placeholder"
               rowHeight={30}
               rowSpacing={5}
               active={true}
               rows={7}
             />
            ) : (
                <RawDataEventsTab teamsData={data?.data || []} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RawDataPage;
